import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDataImportAction implements BaseEnumType {
  private static allValues: EnumDataImportAction[] = []; // make sure this is top-most
  
  public static import = new EnumDataImportAction(0, "Import", "enum_data_import_action_import");
  public static bulkUpdate = new EnumDataImportAction(1, "BulkUpdate", "enum_data_import_action_bulk_update");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDataImportAction.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isImport() { return this === EnumDataImportAction.import; }
  public isBulkUpdate() { return this === EnumDataImportAction.bulkUpdate; }

  public static getValues(): readonly EnumDataImportAction[] {
    return EnumDataImportAction.allValues;
  }

  public static getValuesExcept0(): readonly EnumDataImportAction[] {
    return EnumDataImportAction.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDataImportAction {
    const found = EnumDataImportAction.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDataImportAction - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDataImportAction): EnumDataImportAction {
    const found = name ? EnumDataImportAction.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDataImportAction - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDataImportAction>): boolean {
    return this.key === other?.key;
  }
}